import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { ContainerButtonPlay } from '../../Utils/Button';
import { IMiniCursoResponse } from '../../Interfaces/IMiniCurso';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
// import ScrollToBottomFab from '../FAB/ScrollToBottomFab';

import { grayPlayButton } from '../../Shared/Images';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import atrasIcon from '../../Shared/Images/atras-icon.png';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import styles from '../Main/styles/resultadosPC.module.css';


interface Props {
  data: IMiniCursoResponse[];
}

const MiniCursoVeroPC = ({data} : Props) => { 

  const [mostrarVideo, setMostrarVideo] = useState(false);
  const [dataMiniCurso, setDataMiniCurso] = useState<IMiniCursoResponse>();
  const [currentPosition, setCurrentPosition] = useState<number>(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (data && data.length > 0) {
      setDataMiniCurso({
        descripcion:      data[currentPosition].descripcion,
        miniCursoVideoID: data[currentPosition].miniCursoVideoID,
        titulo:           data[currentPosition].titulo,
        urlVimeoHLS:      data[currentPosition].urlVimeoHLS,
        portada:          data[currentPosition].portada,
        orden:            data[currentPosition].orden,
      });
    }
  }, [currentPosition])

  function retrocederVideo () {
    if(currentPosition !== 0) {
      if(data[currentPosition - 1]) {
        setCurrentPosition( c => c - 1 );
      }
    }
  }
  function avanzarVideo () {
    if(currentPosition + 1 !== data.length) {
      if(data[currentPosition + 1]) {
        setCurrentPosition( c => c + 1 );
      }
    }
  }

  return (
    <div>
      <div>
        <div className="p-4 flex flex-col items-center justify-center gap-4">
          <div className="h-[1vh] w-full"></div>
          <div
            className="flex items-center justify-start w-[90%] m-auto"
            style={{ gap: '1rem', paddingLeft: '1rem' }}
          >
            <img
              onClick={() => navigate('/')}
              src={atrasIcon}
              style={{ width: '35px', height: '25px', cursor: 'pointer' }}
            />
            <p
              style={{ margin: '0', fontWeight: 'bold', fontSize: '1.25rem' }}
              className="title"
            >
              {'Autodisciplina Fit'}
            </p>
          </div>
          <div
            className={styles.containerVideoMenu}
            style={{
              gap: '3rem',
              display: '',
            }}
          >
            <div className={styles.containerVideo}>
              <div className="flex justify-start text-left w-full">
                <p
                  className="m-0 title mb-2 text-[1.25rem]"
                  style={{ color: '#5F5F5F', fontWeight: 'bold' }}
                >
                  {dataMiniCurso?.titulo}
                </p>
              </div>
              {data && data.length > 0 && data[0].urlVimeoHLS && dataMiniCurso && (
                <>
                  <div className="w-[80%] my-4">
                    {!mostrarVideo ? (
                      <div
                        style={{
                          position: 'relative',
                        }}
                        className="relative"
                      >
                        <ContainerButtonPlay
                          onClick={() => {
                            setMostrarVideo(true);
                          }}
                        >
                          <img
                            src={grayPlayButton}
                            alt=""
                            width={80}
                            style={{ cursor: 'pointer' }}
                          />
                        </ContainerButtonPlay>

                        <img
                          width={'100%'}
                          height={'100%'}
                          src={ dataMiniCurso?.portada }
                          alt="portada"
                        />
                      </div>
                    ) : (
                      <VideoPlayer
                        url={ dataMiniCurso?.urlVimeoHLS }
                      />
                    )}
                  </div>
                  <div className="flex flex-col justify-center items-center">
                    <p
                      style={{ textAlign: 'center', fontSize: '1rem', fontWeight: "500" }}
                      className="hind mt-3 w-full text-left"
                      >
                      {dataMiniCurso?.descripcion}
                    </p>

                    <button 
                      className='bg-red-500 hover:bg-[#e95a5a] p-2 text-white rounded-md'
                      style={{boxShadow: `
                        inset 0 4px 6px rgba(255, 255, 255, 0.3),
                        inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                        0 4px 10px rgba(0, 0, 0, 0.25)
                      `}}
                    >
                      <a 
                        href={`https://bonostr4iner.s3.us-east-2.amazonaws.com/workbook_${dataMiniCurso.orden}.pdf`}
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: 'white', fontSize: '1rem' }}
                      >
                        Descarga tu Workbook <TouchAppIcon />
                      </a>
                    </button>

                    

                  </div>

                  <div
                    className="flex items-center justify-center w-full max-w-[950px]"
                    style={{
                      gap: '1rem',
                      paddingLeft: '1rem',
                      marginTop: '1.25rem',
                      marginBottom: '1.5rem',
                    }}
                  >
                    <button
                      className="font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 text-lg opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default"
                      disabled={ currentPosition === 0 ? true : false }
                      onClick={retrocederVideo}
                    >
                    <ArrowBackIosIcon /> Anterior
                    </button>

                    <button
                      className={`font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 text-lg opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default`}
                      disabled={ currentPosition + 1 === data.length ? true : false }
                      onClick={avanzarVideo}
                    >
                      Siguiente <ArrowForwardIosIcon />
                    </button>
                  </div>
                </>
              )}
            </div>
            {/* Menu lateral */}
            <div className={`pt-10 min-w-[20%]`}>
              <div>
                <p
                  className="fw-bold m-0"
                  style={{
                    backgroundColor: '#424242',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '1.4rem',
                  }}
                >
                  Menú
                </p>
                <div style={{ paddingLeft: '1.5rem', marginTop: '.5rem' }}>
                  {data && data.length > 0 && (
                    data?.map((item, i : number) => (
                      <div
                        key={ i }
                        className="flex items-center justify-between p-2 w-full cursor-pointer"
                        style={{
                          backgroundColor: currentPosition === i ? '#373737' : '#fff',
                          padding: '.2rem .5rem',
                          color: currentPosition === i ? 'white' : 'black',
                        }}
                      >
                        <p
                          key={ i }
                          onClick={() => {
                            setMostrarVideo(false);
                            setCurrentPosition(i);
                          }}
                          className="m-0 text-left"
                        >
                          {i + 1}. {item.titulo}
                        </p>
                      </div>
                  )))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <ScrollToBottomFab /> */}

    </div>
  )
};

export default MiniCursoVeroPC;